







import { Component, Prop, Vue } from 'vue-property-decorator'
import VLoader from '@/components/VLoader.vue'

@Component({ components: { VLoader } })
export default class VButton extends Vue {
  @Prop({ default: false }) private loading!: boolean;
  @Prop({ default: false }) private disabled!: boolean;
}
